











import Vue from 'vue'
import PartnerShippingAddressList from '@/components/molecules/PartnerShippingAddress/PartnerShippingAddressList.vue'
import XContainer from '@/components/atoms/Container/XContainer.vue'

export default Vue.extend({
  components: { PartnerShippingAddressList, XContainer },
  data() {
    return {
      partnerId: this.$route.params.partnerId,
    }
  },
  methods: {
    onCreateAddress() {
      this.$router.push({
        name: 'PartnerShippingAddressCreate',
        params: { partnerId: this.partnerId },
      })
    },
  },
})
